export const translations = {
  ar: {
    // Header
    home: 'الرئيسية',
    about: 'من نحن',
    services: 'الخدمات',
    projects: 'المشاريع',
    contact: 'اتصل بنا',
    language: 'English',
    
    // Hero
    discoverMore: 'اكتشف المزيد',
    profilePDF: 'الملف التعريفي',
    contactUs: 'اتصل بنا',
    
    // About
    aboutUs: 'من نحن',
    aboutTitle: 'من نحن',
    ourVision: 'رؤيتنا',
    ourMission: 'مهمتنا',
    yearsExperience: 'سنة خبرة',
    completedProjects: 'مشروع منجز',
    employees: 'موظف',
    clientSatisfaction: 'رضا العملاء',
    downloadProfile: 'تحميل الملف التعريفي',
    downloadCompanyProfile: 'تحميل الملف التعريفي',
    
    // Services
    ourServices: 'خدماتنا',
    servicesDescription: 'نحرص على تركيز اهتمامنا على كل تفاصيل المشروع بداية من أعمال المساحة وتحديد المناسيب حتى الانتهاء من التنفيذ وتسليم المشروع للعميل',
    integratedServices: 'خدمات البناء المتكاملة',
    integratedServicesDesc: 'فريق عمل متكامل من الأيدي العاملة الماهرة ومعدات البناء الحديثة مع ضمان تحقيق السلامة في المرتبة الأولى',
    service1: 'التصميم والمخططات الهندسية',
    service2: 'الإنشاء والتنفيذ',
    service3: 'الصيانة والتشغيل',
    service4: 'إدارة المشاريع',
    service5: 'الاستشارات الهندسية',
    service6: 'أعمال التشطيبات',
    
    // Projects
    ourProjects: 'مشاريعنا',
    projectsDescription: 'ساهمنا في تنفيذ العديد من المشاريع الخاصة والحكومية والمشاريع والعمائر السكنية والتجارية والخيرية',
    allProjects: 'الكل',
    hotel: 'فندقي',
    medical: 'طبي',
    residential: 'سكني',
    investment: 'استثماري',
    charitable: 'خيري',
    viewAllProjects: 'عرض جميع المشاريع',
    projectDetails: 'تفاصيل المشروع',
    owner: 'المالك',
    investor: 'المستثمر',
    designOffice: 'المكتب المصمم',
    supervisor: 'المشرف',
    supplier: 'المورد',
    location: 'الموقع',
    area: 'المساحة',
    projectSize: 'حجم المشروع',
    classification: 'التصنيف',
    contractYear: 'سنة التعاقد',
    completionRate: 'نسبة الإنجاز',
    projectBrief: 'نبذة عن المشروع',
    close: 'إغلاق',
    
    // Qualification
    qualificationTitle: 'التأهيل والتصنيف',
    all: 'الكل',
    hotel: 'فندقي',
    medical: 'طبي',
    residential: 'سكني',
    investment: 'استثماري',
    charitable: 'خيري',
    location: 'الموقع',
    area: 'المساحة',
    year: 'السنة',
    value: 'القيمة',
    completed: 'مكتمل',
    underConstruction: 'قيد التنفيذ',
    
    // Stats/Numbers
    ibtikarInNumbers: 'ابتكار في أرقام',
    workforce: 'القوى العاملة',
    workers: 'عامل',
    engineers: 'مهندس',
    technicians: 'فني',
    achievements: 'الإنجازات والمشاريع',
    completedProject: 'مشروع منجز',
    currentProjects: 'مشاريع حالية',
    executionAreas: 'مساحات تنفيذ',
    yearsOfExperience: 'سنة خبرة',
    
    // Contact
    contactUsTitle: 'اتصل بنا',
    contactDescription: 'نسعد دائماً للتواصل معكم والإجابة على استفساراتكم',
    contactInfo: 'معلومات التواصل',
    phone: 'الهاتف',
    phoneWhatsapp: 'الهاتف / واتساب',
    email: 'البريد الإلكتروني',
    workingHours: 'ساعات العمل',
    workingDays: 'من ٨ صباحًا إلى ٥ مساءًا من السبت للخميس',
    weekend: 'الجمعة مغلق',
    sendMessage: 'أرسل رسالة',
    name: 'الاسم',
    message: 'الرسالة',
    send: 'إرسال',
    sending: 'جاري الإرسال...',
    
    // Footer
    quickLinks: 'روابط سريعة',
    allRightsReserved: 'جميع الحقوق محفوظة'
  },
  en: {
    // Header
    home: 'Home',
    about: 'About Us',
    services: 'Services',
    projects: 'Projects',
    contact: 'Contact',
    language: 'العربية',
    
    // Hero
    discoverMore: 'Discover More',
    profilePDF: 'Company Profile',
    contactUs: 'Contact Us',
    
    // About
    aboutUs: 'About Us',
    aboutTitle: 'About Us',
    ourVision: 'Our Vision',
    ourMission: 'Our Mission',
    yearsExperience: 'Years Experience',
    completedProjects: 'Completed Projects',
    employees: 'Employees',
    clientSatisfaction: 'Client Satisfaction',
    downloadProfile: 'Download Company Profile',
    downloadCompanyProfile: 'Download Company Profile',
    
    // Services
    ourServices: 'Our Services',
    servicesDescription: 'We focus our attention on every detail of the project, starting from surveying and leveling until completion and delivery to the client',
    integratedServices: 'Integrated Construction Services',
    integratedServicesDesc: 'A complete team of skilled workers and modern construction equipment with ensuring safety in the first place',
    service1: 'Design and Engineering Plans',
    service2: 'Construction and Execution',
    service3: 'Maintenance and Operation',
    service4: 'Project Management',
    service5: 'Engineering Consulting',
    service6: 'Finishing Works',
    
    // Projects
    ourProjects: 'Our Projects',
    projectsDescription: 'We have contributed to the implementation of many private and government projects, residential, commercial and charitable buildings',
    allProjects: 'All',
    hotel: 'Hotel',
    medical: 'Medical',
    residential: 'Residential',
    investment: 'Investment',
    charitable: 'Charitable',
    viewAllProjects: 'View All Projects',
    projectDetails: 'Project Details',
    owner: 'Owner',
    investor: 'Investor',
    designOffice: 'Design Office',
    supervisor: 'Supervisor',
    supplier: 'Supplier',
    location: 'Location',
    area: 'Area',
    projectSize: 'Project Size',
    classification: 'Classification',
    contractYear: 'Contract Year',
    completionRate: 'Completion Rate',
    projectBrief: 'Project Brief',
    close: 'Close',
    
    // Qualification
    qualificationTitle: 'Qualification and Classification',
    all: 'All',
    hotel: 'Hotel',
    medical: 'Medical',
    residential: 'Residential',
    investment: 'Investment',
    charitable: 'Charitable',
    location: 'Location',
    area: 'Area',
    year: 'Year',
    value: 'Value',
    completed: 'Completed',
    underConstruction: 'Under Construction',
    
    // Stats/Numbers
    ibtikarInNumbers: 'Ibtikar in Numbers',
    workforce: 'Workforce',
    workers: 'Workers',
    engineers: 'Engineers',
    technicians: 'Technicians',
    achievements: 'Achievements and Projects',
    completedProject: 'Completed Projects',
    currentProjects: 'Current Projects',
    executionAreas: 'Execution Areas',
    yearsOfExperience: 'Years of Experience',
    
    // Contact
    contactUsTitle: 'Contact Us',
    contactDescription: 'We are always happy to communicate with you and answer your inquiries',
    contactInfo: 'Contact Information',
    phone: 'Phone',
    phoneWhatsapp: 'Phone / WhatsApp',
    email: 'Email',
    workingHours: 'Working Hours',
    workingDays: '8 AM to 5 PM, Saturday to Thursday',
    weekend: 'Closed on Friday',
    sendMessage: 'Send Message',
    name: 'Name',
    message: 'Message',
    send: 'Send',
    sending: 'Sending...',
    
    // Footer
    quickLinks: 'Quick Links',
    allRightsReserved: 'All Rights Reserved'
  }
};
